import {useContext} from 'react';
import {ChatbotContext} from '../contexts/chatbot-context';
import {useTranslation} from 'react-i18next';

// we might use this
const thinkingMessage = {
    bot: true,
    isThinking: true,
    question: {
        question: '...'
    },
    type: "MESSAGE"
};

const useMessages = () => {
        const {t} = useTranslation();

        const sleep = (milliseconds) => {
            return new Promise(resolve => setTimeout(resolve, milliseconds));
        };

        const [state, setState] = useContext(ChatbotContext);

        const setCanInteract = () => {
            setState((currentState) => ({
                ...currentState,
                canInteract: true,
            }));
        };

        const addMessage = async (message, ignoreEndOfMessage = false) => {


            if (message.bot) {
                await sleep(800);

                setState((currentState) => ({
                    ...currentState,
                    isThinking: true,
                }));

                await sleep(1400);

                setState((currentState) => ({
                    ...currentState,
                    isThinking: false,
                }));
            }


            const msg = {...message, type: 'MESSAGE'};

            setState((currentState) => ({
                ...currentState,
                messages: [...currentState.messages, msg],
                isThinking: false,
            }));

            // TODO - need to migrate wit to same format
            if(!message.wit){
                /* We want to display a custom message, when we only have one text answer or CHAT followUp */
                const onlyTextOrChatAnswers = message.answers.filter((answer) => answer.followUpAction === 'ANSWER' || answer.followUpAction === 'CHAT').length === message.answers.length;
                if (message.bot && !ignoreEndOfMessage && onlyTextOrChatAnswers) {
                    await addEndOfConversationMessage();
                }
            }
        };

        const showForm = async () => {
            const formMessage = {
                type: 'FORM'
            };

            setState((currentState) => ({
                ...currentState,
                messages: [...currentState.messages, formMessage],
                isThinking: false,
            }));
        };

        const addEndOfConversationMessage = async () => {
            await addMessage({
                bot: true,
                answers: [
                    {
                        translations: [
                            {
                                language: 'ET',
                                text: t('message.assist_more', {lng: 'et'})
                            },
                            {
                                language: 'RU',
                                text: t('message.assist_more', {lng: 'ru'})
                            },
                            {
                                language: 'LV',
                                text: t('message.assist_more', {lng: 'lv'})

                            },
                            {
                                language: 'EN',
                                text: t('message.assist_more', {lng: 'en'})

                            }

                        ],
                        followUpAction: 'ANSWER',
                    }
                ]
            }, true);

            setCanInteract(true);
        };

        return {
            isThinking: state.isThinking,
            messages: state.messages,
            showCommentBox: state.canInteract,
            addMessage,
            setCanInteract,
            showForm,
        };
    }
;

export default useMessages;
